import React, { FC } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { GQL } from "@binale-tech/shared";
import { Code, Kbd, Tooltip } from "@heroui/react";
import { Space } from "antd";

export const CellRendererAiStatus: FC<ICellRendererParams<GQL.IDocument>> = ({ data, node }) => {
    if (!data.aiStatus) {
        return null;
    }
    if (data.aiStatus.status === "progress") {
        return "...";
    }
    if (data.aiStatus.status === "done") {
        const sign = <Code>{data.hasXRechnung ? "E" : "KI"}</Code>;
        if (!data.aiStatus.tags?.length) {
            return sign;
        }
        return (
            <Tooltip
                className={"p-3"}
                content={
                    <Space direction={"vertical"}>
                        {data.aiStatus.tags.map(t => (
                            <Kbd key={`${data.key}:${t}`}>{t}</Kbd>
                        ))}
                    </Space>
                }
            >
                {sign}
            </Tooltip>
        );
    }

    return (
        <Tooltip color={"warning"} content={data.aiStatus.error}>
            <Code color={"warning"}>{data.hasXRechnung ? "E" : "KI"}</Code>
        </Tooltip>
    );
};
